import React, { Component } from 'react';
import { connect } from 'react-redux';

class ListItem extends Component {
    
    constructor(props) {
        super(props);
        this.state = {
            // elements : this.props.elements
        };
    }

    // ############################ RENDER ###################################
    // ############################ RENDER ###################################
    render() {
        const {place, index, selectedItem, custom, variant, historyMode, onDelete} = this.props;
        if (variant === 'search') {
          return (
            <div
              role="button"
              tabIndex={0}
              className={"map-search-suggestion-item" + (selectedItem === index ? " is-active" : "")}
              onMouseDown={(e) => { e.preventDefault(); this.elementSelected(place); }}
              onTouchStart={(e) => { e.preventDefault(); this.elementSelected(place); }}
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  e.preventDefault();
                  this.elementSelected(place);
                }
              }}
            >
              <span className="map-search-suggestion-label">{place.place_name}</span>
              {historyMode && (
                <button
                  type="button"
                  className="map-search-history-remove"
                  aria-label={"Remove " + place.place_name + " from history"}
                  onMouseDown={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    if (onDelete) {
                      onDelete(place);
                    }
                  }}
                  onTouchStart={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    if (onDelete) {
                      onDelete(place);
                    }
                  }}
                >
                  x
                </button>
              )}
            </div>
          );
        }

        return (
        <div className={"BRL Wide100 BottomShadow7 LabelFont btn " + custom +  (selectedItem === index ? " btn-primary " : " btn-light ")} onClick={() => this.elementSelected(place)}>
          {place.place_name}
        </div>
    );
  }


  elementSelected = (data) => {
    const temp ={center: data.center, place: data.place_name};
    // console.log('LIST ITEM => ', temp);
    this.props.onSelected(temp);
  }

}
export default connect(null, null)(ListItem);
